import React, { useEffect,  useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { MainFilter } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import {
  Tforment,
  TrialTFormat,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Trial Balance/TrialBalanceSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";
export default function T_Format({ accountGroup, Fromdate, ToDate }) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { TrialTFormatdata } = useSelector((state) => state.TrialBalanceSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(Tforment());
    dispatch(
      TrialTFormat({
        Firm,
        Year: FinancialYear,
        selectedIds: accountGroup.join(","),
        ToDate,
        Fromdate,
      }),
    );
  }, [dispatch, Firm, FinancialYear, accountGroup, ToDate, Fromdate]);

  const getCrDetailRows = TrialTFormatdata?.CrDetail?.map((item, index) => ({
    srNumber: index + 1,
    AcName: item.AcName,
    AcLaieName: item.AcLaieName,
    GroupMstName: item.GroupMstName,
    BalCrAmt: item.BalCrAmt,
  }));

  const getDrDetailRows = TrialTFormatdata?.DrDetail?.map((item, index) => ({
    srNumber: index + 1,
    AcName: item.AcName,
    AcLaieName: item.AcLaieName,
    GroupMstName: item.GroupMstName,
    BalDrAmt: item.BalDrAmt,
  }));

  /* ================= ORDER BY TYPE ================= */
  const orderByType = (rows = []) => {
    const normalize = (val) => (val || "").toLowerCase();

    const liabilities = rows.filter((r) =>
      normalize(r.AcLaieName).includes("liabil"),
    );
    const assets = rows.filter((r) =>
      normalize(r.AcLaieName).includes("asset"),
    );
    const income = rows.filter((r) =>
      normalize(r.AcLaieName).includes("income"),
    );
    const expenses = rows.filter((r) =>
      normalize(r.AcLaieName).includes("expense"),
    );

    return [...liabilities, ...assets, ...income, ...expenses];
  };

  // const handleDownload = () => {
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   const formatIndianAmount = (value) => {
  //     const num = Number(value || 0);

  //     return num.toLocaleString("en-IN", {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     });
  //   };

  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   const marginX = 14;

  //   /* ================= TITLE ================= */
  //   doc.setFontSize(14);
  //   doc.setFont(undefined, "bold");
  //   doc.text("Trial Balance T-Format", pageWidth / 2, 14, {
  //     align: "center",
  //   });

  //   doc.line(marginX, 17, pageWidth - marginX, 17);

  //   /* ================= FIRM NAME ================= */
  //   const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

  //   doc.setFontSize(11);
  //   doc.text(firmName, pageWidth / 2, 24, {
  //     align: "center",
  //   });

  //   let startY = 38;

  //   /* ================= DATA ================= */
  //   const drRows = orderByType(TrialTFormatdata?.DrDetail || []);
  //   const crRows = orderByType(TrialTFormatdata?.CrDetail || []);

  //   /* ================= TOTALS ================= */
  //   const drTotal = drRows.reduce((s, r) => s + Number(r.BalDrAmt || 0), 0);

  //   const crTotal = crRows.reduce((s, r) => s + Number(r.BalCrAmt || 0), 0);

  //   /* ================= FORMAT ================= */
  //   const formatAmount = (val) => {
  //     if (!val) return "0.00";
  //     return Number(val).toFixed(2);
  //   };

  //   /* ================= COLUMN WIDTH ================= */
  //   const colWidths = [10, 35, 40, 60, 30];
  //   const tableWidth = colWidths.reduce((a, b) => a + b, 0);
  //   const centerX = (pageWidth - tableWidth) / 2;

  //   /* ================= DR TITLE ================= */
  //   doc.setFontSize(12);
  //   doc.setFont(undefined, "bold");
  //   doc.text("Debit Side (Dr)", pageWidth / 2, startY - 6, {
  //     align: "center",
  //   });

  //   /* ================= DR TABLE ================= */
  //   autoTable(doc, {
  //     startY,

  //     margin: { left: centerX },

  //     head: [["Sr", "Ac Type", "Ac Group", "Account Name", "Dr Amount"]],

  //     body: [
  //       ...drRows.map((r, i) => [
  //         i + 1,
  //         r.AcLaieName || "",
  //         r.GroupMstName || "",
  //         r.AcName || "",
  //         formatIndianAmount(r.BalDrAmt),
  //       ]),
  //       ["", "", "", "TOTAL", formatIndianAmount(drTotal)],
  //     ],

  //     theme: "grid",
  //     styles: {
  //       fontSize: 8,
  //       cellPadding: 2,
  //       valign: "middle",
  //       font: "helvetica",
  //     },

  //     bodyStyles: {
  //       fontStyle: "bold",
  //     },
  //     headStyles: {
  //       fillColor: [220, 220, 220],
  //       fontStyle: "bold",
  //       halign: "center",
  //     },

  //     columnStyles: {
  //       0: { halign: "center", cellWidth: colWidths[0] },
  //       1: { cellWidth: colWidths[1] },
  //       2: { cellWidth: colWidths[2] },
  //       3: { cellWidth: colWidths[3] },
  //       4: { halign: "right", cellWidth: colWidths[4] },
  //     },

  //     didParseCell: (data) => {
  //       if (data.row.raw?.[3] === "TOTAL") {
  //         data.cell.styles.fontStyle = "bold";
  //         data.cell.styles.fillColor = [235, 235, 235];
  //       }
  //     },
  //   });

  //   /* ================= NEW PAGE ================= */
  //   doc.addPage();

  //   let startY2 = 22;

  //   /* ================= CR TITLE ================= */
  //   doc.setFontSize(12);
  //   doc.setFont(undefined, "bold");
  //   doc.text("Credit Side (Cr)", pageWidth / 2, startY2, {
  //     align: "center",
  //   });

  //   startY2 += 8;

  //   /* ================= CR TABLE ================= */
  //   autoTable(doc, {
  //     startY,
  //     margin: { left: centerX },

  //     head: [["Sr", "Ac Type", "Ac Group", "Account Name", "Dr Amount"]],

  //     body: [
  //       ...drRows.map((r, i) => [
  //         i + 1,
  //         r.AcLaieName || "",
  //         r.GroupMstName || "",
  //         r.AcName || "",
  //         formatAmount(r.BalDrAmt),
  //       ]),
  //       ["", "", "", "TOTAL", formatAmount(drTotal)],
  //     ],

  //     theme: "grid",

  //     styles: {
  //       fontSize: 8,
  //       cellPadding: 2,
  //       valign: "middle",
  //       font: "helvetica",
  //     },

  //     bodyStyles: {
  //       fontStyle: "bold",
  //     },

  //     headStyles: {
  //       fillColor: [220, 220, 220],
  //       fontStyle: "bold",
  //       halign: "center",
  //     },

  //     columnStyles: {
  //       0: { halign: "center", cellWidth: colWidths[0] },
  //       1: { cellWidth: colWidths[1] },
  //       2: { cellWidth: colWidths[2] },
  //       3: { cellWidth: colWidths[3] },
  //       4: { halign: "right", cellWidth: colWidths[4] },
  //     },

  //     didParseCell: (data) => {
  //       if (data.row.raw?.[3] === "TOTAL") {
  //         data.cell.styles.fontStyle = "bold";
  //         data.cell.styles.fillColor = [235, 235, 235];
  //       }
  //     },
  //   });

  //   /* ================= SAVE ================= */
  //   doc.save("Trial_Balance_T_Format.pdf");
  // };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */

    doc.setFontSize(14);
    doc.setFont(undefined, "bold");

    const title = "Trial Balance T-Format";

    doc.text(title, pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      Firm ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    /* ================= DATA ================= */

    const drRows = orderByType(TrialTFormatdata?.DrDetail || []);
    const crRows = orderByType(TrialTFormatdata?.CrDetail || []);

    /* ================= TOTALS ================= */

    const drTotal = drRows.reduce(
      (sum, row) => sum + Number(row.BalDrAmt || 0),
      0,
    );

    const crTotal = crRows.reduce(
      (sum, row) => sum + Number(row.BalCrAmt || 0),
      0,
    );

    /* ================= TABLE DATA ================= */

    const maxRows = Math.max(drRows.length, crRows.length);

    const tableRows = [];

    for (let i = 0; i < maxRows; i++) {
      const dr = drRows[i];
      const cr = crRows[i];

      tableRows.push([
        i + 1,
        dr?.AcName || "",
        dr ? formatIndianAmount(dr.BalDrAmt) : "",

        cr?.AcName || "",
        cr ? formatIndianAmount(cr.BalCrAmt) : "",
      ]);
    }

    tableRows.push([
      "", // Sr
      "TOTAL", // Debit Account
      formatIndianAmount(drTotal), // Debit Amount
      "TOTAL", // Credit Account
      formatIndianAmount(crTotal), // Credit Amount
    ]);
    /* ================= TABLE WIDTH ================= */

    const colWidths = [15, 85, 35, 85, 35];
    const tableWidth = colWidths.reduce((a, b) => a + b, 0);

    const centerX = (pageWidth - tableWidth) / 2;

    /* ================= TABLE ================= */

    autoTable(doc, {
      startY: 30,

      margin: {
        left: centerX,
      },

      tableWidth,

      head: [
        [
          "Sr",
          "Debit Account",
          "Debit Amount",
          "Credit Account",
          "Credit Amount",
        ],
      ],
      body: tableRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },
      columnStyles: {
        0: {
          cellWidth: colWidths[0],
          halign: "center",
        },
        1: {
          cellWidth: colWidths[1],
        },
        2: {
          cellWidth: colWidths[2],
          halign: "right",
        },
        3: {
          cellWidth: colWidths[3],
        },
        4: {
          cellWidth: colWidths[4],
          halign: "right",
        },
      },
      didParseCell: (data) => {
        if (data.row.raw?.[1] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";

          if ([1, 2, 3, 4].includes(data.column.index)) {
            data.cell.styles.fillColor = [235, 235, 235];
          }
        }
      },
    });

    /* ================= PAGE NUMBER ================= */

    doc.setFontSize(8);
    doc.text("Page 1", marginX, pageHeight - 5);

    /* ================= SAVE ================= */

    doc.save("Trial_Balance_T_Format.pdf");
  };
  if (TrialTFormatdata === "no" || TrialTFormatdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              DEBIT DETAIL
            </h2>
          </div>

          <FASparentMultipalChild
            columns={[
              { label: "Sr. No.", key: "srNumber", align: "center" },
              {
                label: "Ac Type Name",
                key: "AcLaieName",
                align: "left",
                colors: isdark === "light" ? "#000" : "#fff",
              },
              { label: "Count", key: "count", align: "center" },
              {
                label: "AcGroup",
                key: "GroupMstName",
                align: "left",
                colors: isdark === "light" ? "#000" : "#fff",
              },
              {
                label: "Ac Name",
                key: "AcName",
                colors: isdark === "light" ? "#000" : "#fff",
                align: "left",
              },
              {
                label: "Balance DrAmt",
                key: "BalDrAmt",
                align: "right",
                format: true,
              },
            ]}
            data={getDrDetailRows}
            externalTotals={TrialTFormatdata?.DrSummary?.[0] || {}}
          />
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
              position: "relative",
              zIndex: 2,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              CREDIT DETAIL
            </h2>
          </div>

          <FASparentMultipalChild
            columns={[
              { label: "Sr. No.", key: "srNumber", align: "center" },
              {
                label: "Ac Type",
                key: "AcLaieName",
                align: "left",
                colors: isdark === "light" ? "#000" : "#fff",
              },
              { label: "Count", key: "count", align: "center" },
              {
                label: "AcGroup Name",
                key: "GroupMstName",
                align: "left",
                colors: isdark === "light" ? "#000" : "#fff",
              },
              {
                label: "Ac Name",
                key: "AcName",
                align: "left",
                colors: isdark === "light" ? "#000" : "#fff",
              },
              {
                label: "Balance CrAmt",
                key: "BalCrAmt",
                align: "right",
                format: true,
              },
            ]}
            data={getCrDetailRows}
            externalTotals={TrialTFormatdata?.CrSummary?.[0] || {}}
          />
        </div>
      </div>
    </>
  );
}
